import React from 'react';
import PropTypes from 'prop-types';
import { GatewayDest } from 'react-gateway';
import Layout from '../../components/Layout';
import Title from '../../components/Title';
import GiftCardLink from '../../giftCard/GiftCardLink';

const BrandLayout = ({ children, brandName, brandImage, brandLogo }) => (
  <Layout backgroundImage={brandImage} logo={brandLogo} noFooter>
    <Title>{ brandName }</Title>
    <GiftCardLink withBrand className="u-mt- medium-and-up-mt+" />
    <GatewayDest name="subtitle" className="u-show-for-large-and-up" />
    { children }
  </Layout>
);
BrandLayout.propTypes = {
  children: PropTypes.node.isRequired,
  brandName: PropTypes.string,
  brandImage: PropTypes.string,
  brandLogo: PropTypes.string,
};
BrandLayout.defaultProps = {
  brandName: '',
  brandImage: '',
  brandLogo: '',
};

export default BrandLayout;



// WEBPACK FOOTER //
// ./src/app/brands/components/BrandLayout.jsx